import React       from 'react'
import cx          from 'utils/classnames'
import styles      from './styles.module.scss'

const RawHtml = ({ html, className, ...props }) => <div className={cx(styles.rawHtml, className)} dangerouslySetInnerHTML={{ __html: html }} {...props} />

export default RawHtml
